import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DashboardCoursesModule } from '../dashboard-courses/dashboard-courses.module';
import { SharedModule } from '../shared';

import { StandaloneRouting } from './standalone.routing';

import { StandaloneLinkComponent } from './standalone-link/standalone-link.component';

@NgModule({
    declarations: [
        StandaloneLinkComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        StandaloneRouting,
        DashboardCoursesModule
    ]
})
export class StandaloneModule {}